




























import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency.js";
import HsabExpenseCardRowPaymentDetail from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowPaymentDetail.vue";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";

@Component({
  components: { HsabExpenseCardRowPaymentDetail }
})
export default class HsabExpenseCardRowPayment extends Vue {
  formatCurrency = formatCurrency;
  hsabExpenseFormStore = useHsabExpenseFormStore();

  get expense () {
    return this.hsabExpenseFormStore.expense;
  }
  get hasReimbursement () {
    return this.hsabExpenseFormStore.hasExpense && this.expense.reimbursement;
  }

  get hasOverflowReimbursements () {
    return this.hasReimbursement
        && this.expense.reimbursement.overflowReimbursements
        && this.expense.reimbursement.overflowReimbursements.length > 0;
  }
}
